import { render, staticRenderFns } from "./AlunosModal.vue?vue&type=template&id=5c6c4a86&scoped=true"
import script from "./AlunosModal.vue?vue&type=script&lang=js"
export * from "./AlunosModal.vue?vue&type=script&lang=js"
import style0 from "./AlunosModal.vue?vue&type=style&index=0&id=5c6c4a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c4a86",
  null
  
)

export default component.exports